import { render, staticRenderFns } from "./DSExtendDueDate.vue?vue&type=template&id=93da96d0&"
import script from "./DSExtendDueDate.vue?vue&type=script&lang=js&"
export * from "./DSExtendDueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports